import { MIN_PLANNER_WIDTH, useUIStore } from "../store/uiStore";
import { PaneResizeHandle } from "./PaneResizeHandle";

/** Pointer and keyboard resizing for the Planner/Map split. */
export function PlannerMapResizeHandle({
  width,
  maxWidth,
}: {
  width: number;
  maxWidth: number;
}) {
  const setPlannerWidth = useUIStore((state) => state.setPlannerWidth);

  return (
    <PaneResizeHandle
      width={width}
      minWidth={MIN_PLANNER_WIDTH}
      maxWidth={maxWidth}
      onResize={setPlannerWidth}
      label="Resize Planner and Map"
      title="Drag or use arrow keys to resize Planner and Map"
      valueText={`${width} pixels wide`}
      className="group relative z-40 -mx-2 flex w-4 shrink-0 cursor-col-resize touch-none items-center justify-center border-x border-transparent bg-transparent focus:outline-none"
      gripClassName="h-12 w-1 rounded-full bg-primary opacity-30 transition-opacity group-hover:opacity-70 group-focus:opacity-100"
    />
  );
}
